import {
  GET_LIVE_OPS,
  SET_LIVE_OPS,
  TOGGLE_AUTOREFRESH
} from './live-ops.types';
import { AnyAction, Reducer } from 'redux';
import { LiveOpsState } from 'models/redux/liveOps-state';

const initialState: LiveOpsState = {
  liveOps: [],
  liveOpsV2: [],
  liveOpsLoading: false,
  autoRefresh: false,
  interval: undefined
};

const reducer: Reducer<LiveOpsState> = (
  state: LiveOpsState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case GET_LIVE_OPS:
      return { ...state, ...action.payload, liveOpsLoading: true };

    case SET_LIVE_OPS:
      return { ...state, ...action.payload, liveOpsLoading: false };

    case TOGGLE_AUTOREFRESH:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
